import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import VSNTypography from "../../../../shared/VSNTypography";

const boldCells = {
  "Works (Watts)": 6,
  "VO2 mL/kg/min": 5,
  "O2 - Pulse (ml/beat)": 5,
};

export const DynamicTable = ({ tableData = [] }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ maxWidth: "100%", margin: "auto", boxShadow: 3, borderRadius: 2 }}
    >
      <Table>
        <TableHead>
          <TableRow>
            {tableData?.title?.map((col, index) => (
              <TableCell
                key={index}
                sx={{
                  backgroundColor: "#EAEDF0",
                  fontWeight: 700,
                  padding: "8px",
                  color: "#3A3A40",
                }}
              >
                {col}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {tableData?.row?.map((section, sectionIndex) => (
            <React.Fragment key={sectionIndex}>
              {section.category && (
                <TableRow>
                  <TableCell
                    colSpan={tableData?.title?.length}
                    sx={{
                      backgroundColor: "#EAEDF0",
                      fontWeight: 700,
                      padding: "6px",
                      color: "#3A3A40",
                    }}
                  >
                    <VSNTypography
                      variant="subtitle1"
                      sx={{ textAlign: "center" }}
                    >
                      {section.category}
                    </VSNTypography>
                  </TableCell>
                </TableRow>
              )}

              {section?.data?.map((row, rowIndex) => {
                const rowLabel = row?.[0];
                return (
                  <TableRow key={rowIndex}>
                    {row?.map((cell, cellIndex) => {
                      const isBold = boldCells[rowLabel] === cellIndex;

                      return (
                        <TableCell
                          key={cellIndex}
                          sx={{
                            fontWeight: isBold ? 700 : 400,
                            color: "#3A3A40",
                            padding: "8px",
                          }}
                        >
                          {cell}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DynamicTable;
